import { RefreshIndicator } from "material-ui";

export default ({ onRefresh, isRefreshing, style }) => {
  let containerStyle = Object.assign(
    {
      position: "relative",
      float: "right",
      width: 40,
      cursor: "pointer"
    },
    style
  );

  return (
    <div style={containerStyle} onTouchTap={onRefresh}>
      <RefreshIndicator
        left={0}
        top={0}
        status={isRefreshing ? "loading" : "ready"}
        percentage={100}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/partials/table-refresh-indicator.jsx